import React, { useCallback, useEffect, useState } from "react";
import { api } from "@/lib/api";

export default function GoogleAdsStatusPanel() {
  const [status, setStatus] = useState(null);
  const [snapshot, setSnapshot] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const load = useCallback(async () => {
    const [s, data] = await Promise.all([
      api.get("/admin/ai-seo/google-ads/status"),
      api.get("/admin/ai-seo/google-ads/snapshot"),
    ]);
    setStatus(s.data); setSnapshot(data.data);
  }, []);
  useEffect(() => { load().catch(() => setError("No se pudo consultar Google Ads.")); }, [load]);
  const refresh = async () => {
    setBusy(true); setError("");
    try {
      const cid = snapshot?.customerId || status?.customerId;
      await api.post("/admin/ai-seo/google-ads/sync", null, { params: cid ? { customer_id: cid } : {} });
      await load();
    } catch { setError("La lectura de Google Ads ha fallado. No se ha modificado ninguna campaña."); }
    finally { setBusy(false); }
  };
  const periods = Object.values(snapshot?.periods || {});
  const available = (key) => snapshot?.provenance === "REAL" && periods.some((p) => Array.isArray(p[key]));
  const whatsapp = snapshot?.conversionTracking?.whatsappConversionObserved === true;
  const rows = [
    ["Account", snapshot?.accountName || "NO VERIFICADO"],
    ["Customer ID", snapshot?.customerId || status?.customerId || "—"],
    ["API Access Level", status?.apiAccessLevel || "NO VERIFICADO"],
    ["Last Successful Sync", status?.lastSyncAt || snapshot?.syncedAt || "—"],
    ["Campaigns", available("campaigns") ? "AVAILABLE" : "UNAVAILABLE"],
    ["Search Terms", available("searchTerms") ? "AVAILABLE" : "UNAVAILABLE"],
    ["Conversions", available("conversions") ? "AVAILABLE" : "UNAVAILABLE"],
    ["Whatsapp conversion", whatsapp ? "FOUND" : "NOT FOUND"],
    ["Whatsapp metrics", whatsapp && available("conversions") ? "AVAILABLE" : "UNAVAILABLE"],
  ];
  return <section className="border border-[#2A2A2A] p-4 mb-6" data-testid="google-ads-status">
    <div className="flex flex-wrap items-center justify-between gap-3">
      <h2 className="text-[#C9A55A] text-sm">GOOGLE ADS · {error ? "ERROR" : !status ? "LOADING" : status.connected ? "CONNECTED" : "NOT CONNECTED"}</h2>
      <button type="button" className="btn-gold text-xs disabled:opacity-50" disabled={busy || !status?.connected} onClick={refresh} data-testid="google-ads-refresh">
        {busy ? "LEYENDO…" : "REFRESCAR GOOGLE ADS"}
      </button>
    </div>
    <p className="text-xs text-[#8A8A8A] my-3">Solo lectura. No modifica campañas, presupuestos ni conversiones.</p>
    {error && <p role="alert" className="text-red-400 text-sm">{error}</p>}
    <dl className="grid grid-cols-1 md:grid-cols-3 gap-3 text-xs">
      {rows.map(([name, value]) => <div key={name}><dt className="text-[#8A8A8A]">{name}</dt><dd className="text-[#F5F1EB] break-words">{value}</dd></div>)}
    </dl>
  </section>;
}
